const plansData = [
  {
    type: "Personal",
    pricing: "24",
    pricingYearly: "125",
    description: "Perfect for freelancers or any other design enthusiast",
    details: [
      "Unlimited mobile & web flows",
      "Discover latest apps, screens and flows",
      "Download design file in Figma",
      "UX process explained",
      "Personal & commercial license",
      "Cancel anytime"
    ],
    action: "Upgrade to Personal Plan",
    bg: 'bg-green-200'
  },
  {
    type: "Teams",
    pricing: "40",
    pricingYearly: "188",
    description: "Perfect for any design teams, agencies, and enterprises.",
    details: [
      "Unlimited mobile & web flows",
      "Discover latest apps, screens and flows",
      "Download design file in Figma",
      "Download coded files in Html, CSS React, Ionic",
      "UX process explained",
      "Cancel anytime"
    ],
    action: "Upgrade to Team Plan",
    bg: 'bg-purple-200'
  },
];

export default plansData
